var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-center"},[_c('amplify-authenticator',{attrs:{"id":"amplify-auth","auth-config":_vm.authConfig}}),(_vm.showSignOut)?_c('amplify-sign-out'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }